import { render, staticRenderFns } from "./PasswordChangePopup.vue?vue&type=template&id=42038b4f&scoped=true"
import script from "./PasswordChangePopup.vue?vue&type=script&lang=ts"
export * from "./PasswordChangePopup.vue?vue&type=script&lang=ts"
import style0 from "./PasswordChangePopup.vue?vue&type=style&index=0&id=42038b4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42038b4f",
  null
  
)

export default component.exports